import i18next from "src/locales/i18n";
import { useTranslation } from "react-i18next";
import { plPL, enUS } from "@mui/material/locale";
import { Storage } from "src/utils/storage";
import { useNavigate } from "react-router";

const LANGS = [
    {
        label: i18next.t("shared.langpl"),
        value: "pl",
        systemValue: plPL,
        icon: "https://upload.wikimedia.org/wikipedia/commons/1/12/Flag_of_Poland.svg",
    },
    {
        label: i18next.t("shared.langen"),
        value: "en",
        systemValue: enUS,
        icon: "https://upload.wikimedia.org/wikipedia/commons/a/a5/Flag_of_the_United_Kingdom_(1-2).svg",
    },
];

export default function useLocales() {
    const { i18n, t } = useTranslation();
    const navigate = useNavigate();
    const langStorage = Storage.getItem("i18nextLng");

    const currentLang = LANGS.find((_lang) => _lang.value === langStorage) || LANGS[0];

    const handleChangeLanguage = (newlang: string) => {
        i18n.changeLanguage(newlang).finally(() => {
            Storage.setItem("i18nextLng", newlang);
            navigate(0);
        });
    };

    return {
        onChangeLang: handleChangeLanguage,
        t,
        currentLang,
        allLang: LANGS,
    };
}
